<template>
  <BaseListHeader>
    <div class="flex -mx-4">
      <div class="w-24 px-4" />
      <div class="flex-1 px-4">Name</div>
      <div class="w-24 px-4 text-right">Cost</div>
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
